import React, { useContext } from 'react';
import { observer } from 'mobx-react-lite';
import Tree from '../tree/Tree';
import SubGroups from './SubGroups';
import TableContext from '../../TableContext';
const Group = observer(function Group(props) {
    const { header, records, value, onDragEnd, treeNodeRenderer, treeNodeSuffix } = props;
    const { prefixCls } = useContext(TableContext);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: `${prefixCls}-customization-tree-group-header` }, header),
        React.createElement(Tree, { value: value },
            React.createElement(SubGroups, { records: records, onDragEnd: onDragEnd, treeNodeRenderer: treeNodeRenderer, treeNodeSuffix: treeNodeSuffix }))));
});
Group.displayName = 'Group';
export default Group;
